import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import { LinearCalendarButton } from '../../components/Buttons'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { getBidMode, BidMode } from '../../scenes/BidSession/helpers.js';
import * as bidSessionActions from '../../data/bidSession/actions';
import Statistic from './Statistic';
import {
  getUTC,
  formatActivityDate
} from './../../utilities/calendarUtilities';
import * as bidClassesActions from './../../data/bidClasses/actions';
import { ADD_REQUEST } from './../../data/constants/index.js';
import { useLanguage } from '../../context/LanguageContext';

const LinearCalendarDay = props => {
  const { labels } = useLanguage();
  const ADDING_BID = labels.ADDING_BID || {};
  const DAY_CALENDAR_MENU = labels.DAY_CALENDAR_MENU || {};
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [isSaving, setIsSaving] = useState(false)

  const onHandleClick = event => {
    event.preventDefault();
    setOpen(!open)
    setAnchorEl(event.currentTarget)
  };

  const handleRequestClose = () => setOpen(false)

  const handleAddDayOff = () => {
    const { calendarDay, showNotification, handleActionPreference, totalEntries } = props;
    const { bidSessionId } = props.bidSession.currentBid;
    const updateNextAvailableLevel = () => {
      if (getBidMode() !== BidMode.LADDER.biddingMode) {
        return;
      }
      const nextAvailableLevel =
        bidSessionActions.default.getNextAvailableLevel(
          props.bidSession.bidPreferences,
          props.bidSession.bidLevels,
          props.bidSession.allowDuplicates
        );
      props.bidSession.nextAvailableLevel = nextAvailableLevel;
    };
    let value = formatActivityDate(calendarDay).split(' ')[0];
    value = value.replace(value.slice([10]), '');

    const { parameterValues, wish, preferenceOptionId } = {
      ...ADD_REQUEST.DAY_OFF
    };
    parameterValues[0].value = value;

    updateNextAvailableLevel();
    const bidSession = {
      currentBid: {
        bidSessionId
      },
      bidPreferences: props.bidSession.bidPreferences,
      bidMode: props.bidSession.bidMode,
      nextAvailableLevel: props.bidSession.nextAvailableLevel
    };

    const editPreference = {};

    bidClassesActions.default
      .savePreference(
        bidSession,
        preferenceOptionId,
        parameterValues,
        editPreference,
        wish
      )()
      .then(response => {
        setIsSaving(false)
        setOpen(false)
        showNotification(ADDING_BID.ADD_MESSAGE);
        handleActionPreference(response, true);
        updateNextAvailableLevel();
      })
      .catch(e => {
        setIsSaving(false)
        setOpen(false)
        showNotification(e.response.data.message);
      });
  };

  const resetHours = date => {
    if (!date) return null;
    if (typeof date.getMonth !== 'function') {
      date = getUTC(date);
    }
    return date.setHours(0, 0, 0, 0);
  };

  const currentStatistic = props.statistics.filter(statistic => resetHours(statistic.date) === resetHours(props.calendarDay));

  const percentage =
    currentStatistic.length > 0 ? currentStatistic[0].percentage : -1;
  const isBufferDay = props.className.includes('CarryInOutDay');
  const content = (
    <div>
      <div className='Number'>{props.dayNumber}</div>
      <div className='Day'>{props.dayString}</div>
      <Statistic percentage={percentage} />
    </div>
  );
  return (
    <div
      style={{ width: props.width }}
      className={props.className}
      key={props.id}
    >
      <div
        className={(isBufferDay || !props.bidSession.displayDayOffOption || props.reportMode) ? 'click-wrapper buffer' : 'click-wrapper'}
        onClick={(isBufferDay || !props.bidSession.displayDayOffOption || props.reportMode) ? () => {} : onHandleClick}
      >
        {(isBufferDay || !props.bidSession.displayDayOffOption || props.reportMode) ? (
          content
        ) : (
          <Tooltip title={props.bidSession.displayDayOffOption && DAY_CALENDAR_MENU.TOOLTIP}>
            <LinearCalendarButton>
              {content}
            </LinearCalendarButton>
          </Tooltip>

        )}
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        onRequestClose={handleRequestClose}
        disableScrollLock={false}
      >
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleRequestClose}
          onClick={handleRequestClose}
        >
          <MenuItem onClick={handleAddDayOff}>{DAY_CALENDAR_MENU.OPTIONS.ONE}</MenuItem>
        </Menu>
      </Popover>
    </div>
  );

}

LinearCalendarDay.propTypes = {
  width: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  dayNumber: PropTypes.number.isRequired,
  dayString: PropTypes.string.isRequired,
  statistics: PropTypes.array.isRequired,
  calendarDay: PropTypes.instanceOf(Date).isRequired,
  handleActionPreference: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  bidSession: PropTypes.shape({
    currentBid: PropTypes.object,
    bidPreferences: PropTypes.object
  }),
  totalEntries: PropTypes.number.isRequired
};

export default LinearCalendarDay;
